import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["href", "onClick"],
  _excluded2 = ["children"];
import React from 'react';
import Avatar from '@atlaskit/avatar';
import { ButtonItem, CustomItem, LinkItem } from '@atlaskit/menu';
var AvatarGroupItem = function AvatarGroupItem(_ref) {
  var avatar = _ref.avatar,
    onAvatarClick = _ref.onAvatarClick,
    testId = _ref.testId,
    index = _ref.index;
  var href = avatar.href,
    onClick = avatar.onClick,
    rest = _objectWithoutProperties(avatar, _excluded);
  var CustomComponent = function CustomComponent(_ref2) {
    var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded2);
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/React.createElement("span", props, children);
  };
  var AvatarIcon = /*#__PURE__*/React.createElement(Avatar, _extends({}, rest, {
    testId: testId && "".concat(testId, "--avatar"),
    borderColor: "transparent",
    size: "small",
    name: ""
  }));

  // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
  var callback = onClick || onAvatarClick;
  if (href) {
    return /*#__PURE__*/React.createElement(LinkItem, {
      href: href,
      target: avatar.target,
      rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
      iconBefore: AvatarIcon,
      testId: testId,
      onClick: function onClick(event) {
        return callback && callback(event, undefined, index);
      }
    }, avatar.name);
  }
  if (typeof callback === 'function') {
    return /*#__PURE__*/React.createElement(ButtonItem, {
      onClick: function onClick(event) {
        return callback && callback(event, undefined, index);
      },
      iconBefore: AvatarIcon,
      testId: testId
    }, avatar.name);
  }
  return /*#__PURE__*/React.createElement(CustomItem, {
    iconBefore: AvatarIcon,
    component: CustomComponent,
    testId: testId
  }, avatar.name);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default AvatarGroupItem;